export default __webpack_public_path__ + "static/team-Mustafa-ba2dd06a5c1157a278e683c69fc48de9.png";